import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { Avatar, Box, Typography } from '@mui/material';
import clsx from 'clsx';
import TimeAgo from 'javascript-time-ago';
import { useTranslation } from 'react-i18next';
import { NotificationFieldsFragment } from '../../../../../../../../generated/core-api/graphql-react-query';

export default function ProjectAssignedNotificationBox(props: { notification: NotificationFieldsFragment }) {
  const { notification } = props;
  const { t, i18n } = useTranslation('widgets');
  const timeAgo = new TimeAgo(i18n.language);

  return (
    <>
      <Avatar className="user">
        <AccountTreeIcon />
      </Avatar>
      <Box className="message">
        <Typography variant="subtitle1">
          <strong>{notification.event.author?.displayName}</strong>
          {t('notifications.project.assigned')}
        </Typography>
        <Typography variant="body1" component="div">
          <div className={clsx('project', { deleted: notification.event.project?.archived })}>{notification.event.project?.name}</div>
        </Typography>
        <Typography variant="subtitle2">
          {timeAgo.format(new Date(notification.date))}
        </Typography>
        <Typography variant="subtitle2">
          {notification.event.project?.archived && `${t('notifications.deleted')} ${timeAgo.format(new Date(notification.date))}`}
        </Typography>
      </Box>
    </>
  );
}
